import '@babel/polyfill';
import 'raf/polyfill';
import React from 'react';
import { hydrate } from 'react-dom';
import './commoncss/reset.css';
import { Layout } from './layout/';

/* eslint-disable no-undef */
hydrate(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable no-undef */
